var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargingLocations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74564 14.3339L6.39892 13.5262L8.04185 10.7872H4.11328L7.18464 5.66907L8.53135 6.47678L6.88842 9.21578H10.817L7.74564 14.3339Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.92855H21.2143V0.571411H19.6429V2.92855H18.8571V7.64284H19.6429V16.6786C19.6429 16.9911 19.5187 17.2909 19.2977 17.5119C19.0766 17.733 18.7769 17.8571 18.4643 17.8571C18.1517 17.8571 17.8519 17.733 17.6309 17.5119C17.4099 17.2909 17.2857 16.9911 17.2857 16.6786V9.99998C17.2857 9.7916 17.2029 9.59175 17.0556 9.4444C16.9082 9.29705 16.7084 9.21427 16.5 9.21427H13.3571V1.35713C13.3571 1.14874 13.2744 0.948892 13.127 0.801542C12.9797 0.654192 12.7798 0.571411 12.5714 0.571411H2.35714C2.14876 0.571411 1.94891 0.654192 1.80156 0.801542C1.65421 0.948892 1.57143 1.14874 1.57143 1.35713V17.8571H0V19.4286H14.9286V17.8571H13.3571V10.7857H15.7143V16.6786C15.7143 17.4079 16.004 18.1074 16.5197 18.6231C17.0355 19.1388 17.7349 19.4286 18.4643 19.4286C19.1936 19.4286 19.8931 19.1388 20.4088 18.6231C20.9246 18.1074 21.2143 17.4079 21.2143 16.6786V7.64284H22V2.92855ZM11.7857 17.8571H3.14286V2.14284H11.7857V17.8571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingLocations);
export default __webpack_public_path__ + "static/media/charging-locations.9cc7f3727a4ee82db60bda52b38cf291.svg";
export { ForwardRef as ReactComponent };